import { NONE_TYPE } from './types/shared';
import { UserType } from './types/user';
import { EventType } from './types/event';
import { DependentType } from './types/dependent';

export const NONE: NONE_TYPE = 'none';
export const ANY = 'any';

export const defaultUserType: UserType = { kind: ANY, subkind: NONE, value: NONE };
export const defaultEventType: EventType = { kind: ANY, subkind: NONE, value: NONE };
export const defaultNotEventType: EventType = { kind: ANY, subkind: NONE, value: NONE };
export const defaultDependentType: DependentType = { kind: NONE, subkind: NONE, value: NONE };
